module.exports = __webpack_public_path__ + "8b5cfe1791e422092de11f245ed32e94.ttf";